import React, {Component} from 'react'
import { MainHeader, MainFooter } from '../Components'

import qs from 'qs'
import axios from 'axios'

import firebase from '../Configs/firebase'
import Config from '../Configs/staticConfig'
import './Css/PageLogin.css'

class Login extends Component{
    constructor(props){
        super(props);
        this.state={
            email:'',
            password:'',
            name:'',
            phone:'',
            isSignUp:false,
            isLoading:false
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleFacebook = this.handleFacebook.bind(this)
        this.handleLine = this.handleLine.bind(this)
        this.handleSelectedTab = this.handleSelectedTab.bind(this)
        this.handleViewPassword = this.handleViewPassword.bind(this)
        this.handleForgotPassword = this.handleForgotPassword.bind(this)
        this.loginWithCustomToken = this.loginWithCustomToken.bind(this)
    }

    componentDidMount(){
        const parsed = qs.parse(window.location.search);
        if(parsed.state === '12345abcde'){

            this.setState({isLoading:true})
            
            var body = {
                code : parsed['?code']
            }
            axios.post(Config.getLineIdTokenUrl(),body)
            .then(res=>{
                var body = {
                    secretId:'lineloginsecret',
                    mid:res.data.id_token.sub,
                    displayName:res.data.id_token.name,
                    photoUrl:res.data.id_token.photo
                }
                return axios.post(Config.getVerifyLineTokenUrl(),body)
            })
            .then(res=>{
                this.loginWithCustomToken(res.data.token)
            })
            .catch(err=>{
                console.log(err)
            })
        } 
    }

    handleSubmit(event){
        event.preventDefault()
        const { isSignUp } = this.state
        
        this.setState({isLoading:true})
        
        if( !isSignUp ){
            firebase.auth().signInWithEmailAndPassword(this.state.email,this.state.password)
            .then(()=>{
                this.setState({isLoading:false})
            })
            .catch(err=>{
                this.setState({isLoading:false})
                alert(err)
            })
        }
        else{
            firebase.auth().createUserWithEmailAndPassword(this.state.email,this.state.password)
            .then((user)=>{
                return firebase.firestore().collection('users').doc(user.user.uid).set({
                    email:this.state.email,
                    name:this.state.name,
                    available_storage:3221225472,
                    total_storage:3221225472,
                    hosting:true,
                    phone:this.state.phone,
                    created_date:new Date()
                })
            })
            .then(()=>{
                var user = firebase.auth().currentUser
                return user.updateProfile({
                    displayName:this.state.name
                })
            })
            .then(()=>{
                this.setState({isLoading:false})
            })
            .catch(err=>{
                this.setState({isLoading:false})
                alert(err)
            }) 
        }    
    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState(() => ({
            [name]: value
        }))
    }

    handleSelectedTab(e,bool){
        e.preventDefault()
        this.setState({isSignUp:bool})
    }
    
    handleFacebook(event){
        event.preventDefault()
        firebase.auth().signInWithPopup(new firebase.auth.FacebookAuthProvider())
        .then(()=>{
            this.setState({isLoading:false})
        })
        .catch(err=>{
            alert(err)
        })
    }

    handleLine(event){
        event.preventDefault()
        window.location.replace(Config.getLineLoginWeb()) 
    }

    loginWithCustomToken(token){
        firebase.auth().signInWithCustomToken(token)
        .then(()=>{
            this.setState({isLoading:false})
        })
        .catch(err=>{
            this.setState({isLoading:false})
            alert(err)
        })
        window.history.pushState({}, null, Config.getMymapPageLink());
    }

    handleViewPassword(){
        var input = document.getElementById("passwordInput")
        if (input.type === "password") {
            input.type = "text";
            document.getElementById("eyeIcon").className = "far fa-eye-slash is-inner"
        }else {
            input.type = "password";
            document.getElementById("eyeIcon").className = "far fa-eye is-inner"
        }
    }

    handleForgotPassword(){
        window.open(Config.getResetPasswordPageLink())
    }

    render(){
        const { email, password, isSignUp, name, phone, isLoading } = this.state;
        var content = null 
        var spinner = null
        var singUpTab = {
            className : 'tablinks',
        }
        var loginTab = {
            className : 'tablinks',
        }

        if(!isSignUp){
            loginTab.className = 'tablinks active'
            content =   <form onSubmit={this.handleSubmit}>
                            <div className="field">
                                <label className="label">Email</label>
                                <div className="control">
                                    <input className="input is-rounded" type="text" onChange={this.handleChange} name='email' value={email} placeholder="email@mail.com"></input>
                                </div>
                            </div>
                            <div className="field">
                                <label className="label">Password</label>
                                <div className="control">
                                    <input className="input is-rounded" id="passwordInput" type="password" onChange={this.handleChange} name='password' value={password} placeholder="password"></input>
                                    <i id="eyeIcon" className="fas fa-eye is-inner" onClick={this.handleViewPassword}></i>
                                    <br/>
                                </div>
                            </div>
                            <div className="divBtn">
                                <input className="button is-primary is-rounded is-maxwidth " type="submit" value="เข้าสู่ระบบ" />
                            </div>
                            <div className="is-text-center">
                                <div className="in-line-display text-grey" onClick={this.handleForgotPassword}>ลืมรหัสผ่าน</div>
                            </div>
                            <div className="hr-sect">or</div>
                            <div className="divBtn">
                                <input className="button is-facebook is-rounded is-maxwidth" type="submit" value="เข้าสู่ระบบด้วย Facebook" onClick={this.handleFacebook}/>
                                <i className="fab fa-facebook-square is-left-inner"></i>
                            </div>
                            <div className="divBtn">
                                <input className="button is-line is-rounded is-maxwidth" type="submit" value="เข้าสู่ระบบด้วย Line" onClick={this.handleLine}/>
                                <i className="fab fa-line is-left-inner" ></i>
                            </div>
                        </form>
        }
        else{
            singUpTab.className = 'tablinks active'
            content =   <form onSubmit={this.handleSubmit}>
                            <div className="field">
                                <label className="label">Email</label>
                                <div className="control">
                                    <input className="input is-rounded" type="text" onChange={this.handleChange} name='email' value={email} placeholder="email@mail.com"></input>
                                </div>
                            </div>
                            <div className="field">
                                <label className="label">Password</label>
                                <div className="control">
                                    <input className="input is-rounded" id="passwordInput" type="password" onChange={this.handleChange} name='password' value={password} placeholder="password"></input>
                                    <i id="eyeIcon" className="fas fa-eye is-inner" onClick={this.handleViewPassword}></i>
                                    <br/>
                                </div>
                            </div>
                            <div className="field">
                                <label className="label">ชื่อ-นามสกุล</label>
                                <div className="control">
                                    <input className="input is-rounded" type="text" onChange={this.handleChange} name='name' value={name} placeholder="name"></input>
                                    <br/>
                                </div>
                            </div>
                            <div className="field">
                                <label className="label">เบอร์โทรศัพท์</label>
                                <div className="control">
                                    <input className="input is-rounded" type="text" onChange={this.handleChange} name='phone' value={phone} placeholder="08xxxxxxxx"></input>
                                    <br/>
                                </div>
                            </div>
                            <div className="divBtn">
                                <input className="button is-primary is-rounded is-maxwidth" type="submit" value="สมัครสมาชิก" />
                            </div>
                        </form>
        }

        if(isLoading) spinner = <div className="spinner"></div>

        return (
                    <div className="InnerApp">
                        <MainHeader user={this.props.user}/>
                        <section className="UploadLanding hero">
                            <div className="hero-body"></div>
                        </section>
                        <section className="LoginForm section">
                            <div className="container">
                                <div className="box">
                                <div className="tab">
                                    <button id="loginTab" className={loginTab.className} onClick={(e)=>this.handleSelectedTab(e,false)}>
                                        เข้าสู่ระบบ
                                    </button>
                                    <button id="signUpTab" className={singUpTab.className} onClick={(e)=>this.handleSelectedTab(e,true)}>
                                        สมัครสมาชิก
                                    </button>
                                </div>
                                    {spinner}
                                    {content}     
                                </div>
                            </div>
                        </section>
                        <MainFooter />            
                    </div>
        )
    }
}

export default Login


// WEBPACK FOOTER //
// ./src/PageLogin/_Login.js